var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppLayout",
    {
      attrs: {
        page: "/dashboard",
        pageTitle: "Founders Memberships",
        backLink: "/dashboard/reports",
      },
    },
    [
      _c(
        "v-col",
        { staticClass: "pa-1", attrs: { cols: "12" } },
        [
          _c("Stats", { staticClass: "pb-3", attrs: { stats: _vm.stats } }),
          _vm._v(" "),
          _c(
            "v-card",
            { staticClass: "soli-round" },
            [
              _c(
                "v-container",
                { staticClass: "px-3", attrs: { fluid: "" } },
                [
                  _c("ReportHeader", {
                    attrs: {
                      filter: "",
                      reportUrl: "/dashboard/reports/founders-memberships",
                    },
                    on: {
                      search: function ($event) {
                        _vm.search = $event
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("v-data-table", {
                    ref: "table",
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.founders,
                      "hide-default-footer": "",
                      "disable-pagination": "",
                      "mobile-breakpoint": "0",
                      search: _vm.search,
                    },
                    on: {
                      "current-items": function ($event) {
                        return _vm.collapse()
                      },
                      "click:row": function ($event) {
                        ;[_vm.$log($event.id)]
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: `group.header`,
                          fn: function ({ group, items, isOpen, toggle }) {
                            return [
                              _c(
                                "th",
                                { attrs: { colspan: "8" } },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      staticClass:
                                        "flex justify-start align-center pa-2",
                                      attrs: { "no-gutters": "" },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "mr-3",
                                          on: { click: toggle },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(isOpen ? "remove" : "add") +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("v-col", [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "soli-grey text-subtitle-2 font-weight-bold",
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(group) +
                                                "\n                                    "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "soli-grey text-small",
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        • " +
                                                _vm._s(items.length) +
                                                " Lead(s)\n                                    "
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: `item.info.name`,
                          fn: function ({ item }) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex align-center py-2 soli-grey",
                                },
                                [
                                  _c(
                                    "div",
                                    [
                                      item.info.user_id
                                        ? _c(
                                            "Link",
                                            {
                                              attrs: {
                                                href: `/profile/${item.info.user_id}/account`,
                                              },
                                            },
                                            [
                                              _c("v-list-item-title", [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.info.name) +
                                                    "\n                                    "
                                                ),
                                              ]),
                                            ],
                                            1
                                          )
                                        : _c("v-list-item-title", [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(item.info.name) +
                                                "\n                                "
                                            ),
                                          ]),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-item-subtitle",
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(item.info.email) +
                                              "\n                                    "
                                          ),
                                          item.info.email
                                            ? _c("Clipboard", {
                                                attrs: {
                                                  text: item.info.email,
                                                  label: "Copy Email",
                                                  "x-small": "",
                                                },
                                              })
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }